<template>
  <div class="sppucDataTable" :style="{height:isLarge?'calc(100% - 0.4rem)':''}">
    <div class="makerTableContent" :style="{'padding-left':isLeftDrawVisible?'2.6rem':'','padding-right':isRightDrawVisible?'2.6rem':''}">
      <div class="header">
        <div class="left">
          <span class="name">{{layerData.name}}</span>
          <span v-if="layerData.extendConfig.isSppucData===true" class="text">（共 <span style="color: white">{{total}}</span> 条记录）</span>
          <span v-else class="text">（已选择 <span style="color: white">{{selectedData.length}}</span> 条，共 <span style="color: white">{{total}}</span> 条记录）</span>
        </div>
        <div class="right">
          <div class="line"></div>
          <el-tooltip content="删除" v-if="layerData.extendConfig.isSppucData===false&&!shared" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-ashbin" @click="deleteMore" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
          </el-tooltip>
          <el-tooltip content="放大" placement="top" effect="light" @click.native="setLarge(true)" v-if="!isLarge" :open-delay="1000" :enterable="false">
            <Icon name="icon-fullscreen-expand"></Icon>
          </el-tooltip>
          <el-tooltip content="缩小" placement="top" effect="light" @click.native="setLarge(false)" v-else :open-delay="1000" :enterable="false">
            <Icon name="icon-fullscreen-shrink"></Icon>
          </el-tooltip>
          <el-tooltip content="导入数据" v-if="layerData.extendConfig.isSppucData===false&&!shared" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <el-upload class="flex" :limit="1" action="" ref="excelUpload" :show-file-list="false" :auto-upload="true" :http-request="showImportMarker"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" :disabled="permissionLevel <= PermissionLevel.LOOKER">
              <Icon name="icon-shangchuan-copy"></Icon>
            </el-upload>
          </el-tooltip>
          <el-tooltip content="关闭" placement="top" effect="light" @click.native="close" :open-delay="1000" :enterable="false">
            <Icon name="icon-close-bold"></Icon>
          </el-tooltip>
        </div>
      </div>
      <div class="tableBox" @mousewheel="handleScroll">
      <el-table
        v-if="keep"
        v-loading="loading"
        stripe
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
          ref="multipleTable"
          id="multipleTable"
          :data="tableData"
          height="100%"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          v-el-table-infinite-scroll="loadMore"
          @cell-click="clickItem">
        <el-table-column
          v-if="layerData.extendConfig.isSppucData===false"
          type="selection"
          class="selection"
          :width="55*zoomFactor">
        </el-table-column>
        <el-table-column label="序号" :width="60*zoomFactor">
          <template slot-scope="scope">
            <span class="num">{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="标注名称" prop="name" :width="columns && columns.length>9?203*zoomFactor:'auto'" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-for="(item ,index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="columns && columns.length>9?203*zoomFactor:'auto'"
          :formatter="item.formatter"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" :fixed="columns && columns.length>9?'right':undefined" :width="80*zoomFactor" v-if="layerData.extendConfig.isSppucData===false&&!shared">
          <template slot-scope="scope">
            <div class="action-btn">
              <el-tooltip content="编辑" placement="top" effect="light" :open-delay="1000" :enterable="false">
                <Icon name="icon-edit" @click.stop="openEdit(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
              </el-tooltip>
              <el-tooltip content="删除" placement="top" effect="light" :open-delay="1000" :enterable="false">
                <Icon name="icon-ashbin" @click.stop="deleteOne(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <Empty></Empty>
        </template>
      </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import page from '@/mixins/page'
// import * as dataManagement from '@/api/dataManagement'
// import { dataset2table, coordTransform } from '@/utils/util'
import { getMarkerList, delMarker } from '@/api/marker'
import { PermissionLevel } from '@/configs/constants'

export default {
  name: 'SppucDataTable',
  props: {
    layerData: {
      type: Object,
      default: null
    }
  },
  mixins: [page],
  inject: ['shared', 'cesiumViewer'],
  data () {
    return {
      isLarge: false,
      gisHeader: {},
      columns: [],
      // 所有表格数据
      allTableData: [],
      // 加载表格数据
      tableData: [],

      apiConfig: {},
      isShow: false,
      params: {
        layerId: null,
        pageNumber: 1,
        pageSize: 20
      },
      isNext: false, // 判断是否有下一页
      total: 0,
      loading: false,
      selectedRowId: undefined,
      keep: true,
      PermissionLevel
    }
  },
  computed: {
    // _layerData () {
    //   return this.layerData
    // },
    ...mapGetters(['isLeftDrawVisible', 'isRightDrawVisible', 'apiSourceDatas', 'permissionLevel', 'updateSppucDevice'])
  },
  mounted () {
    if (this.layerData.module !== 'sppuc') {
      return
    }
    this.refreshTableData()
  },
  watch: {
    layerData (val, oldVal) {
      if (val.module !== 'sppuc') {
        return
      }
      if (oldVal && val.id === oldVal.id) {
        return
      }
      this.params.pageNumber = 1
      this.refreshTableData()
    },
    updateSppucDevice (val) {
      if (this.layerData.extendConfig.isSppucData) {
        // if (val.type !== 'update') {
        //   this.refreshTableData()
        // }
        this.refreshTableData()
      }
    }
  },
  beforeDestroy () {

  },
  methods: {
    handleScroll () {
      const tooltips = document.getElementsByClassName('el-tooltip__popper')
      if (tooltips.length > 0) {
        tooltips[tooltips.length - 1].style.display = 'none'
      }
    },
    setLarge (isLarge) {
      this.isLarge = isLarge
      setTimeout(() => {
        this.reDrawTable()
      }, 300)
    },
    async reDrawTable () {
      this.keep = false
      await this.$nextTick()
      this.keep = true
    },
    showImportMarker (file) {
      const data = {
        layerId: this.layerData.id,
        file: file.file
      }
      this.$emit('showImportMarker', data)
    },
    // 获取图层属性
    getTableHeader () {
      this.columns = []
      this.columns.push({
        prop: 'deviceId',
        label: '设备ID'
      })
      this.columns.push({
        prop: 'marker_lon',
        label: '经度_WGS84'
      })
      this.columns.push({
        prop: 'marker_lat',
        label: '纬度_WGS84'
      })
      this.columns.push({
        prop: 'marker_height',
        label: '高度'
      })
    },
    loadAllData () {
      if (this.layerData.extendConfig.isSppucData) {
        const datas = this.cesiumViewer.sppucManager.getDevicesOl(this.layerData.extendConfig.deviceType)
        this.total = datas.length
        this.allTableData = datas.map(item => {
          return {
            name: item.name,
            deviceId: item.id,
            marker_lon: item.position[0],
            marker_lat: item.position[1]
          }
        })
        const count = Math.min(this.params.pageNumber * this.params.pageSize, this.allTableData.length)
        this.tableData = this.allTableData.slice(0, count)
      } else {
        this.loadMarkers()
      }
    },
    async loadMarkers () {
      this.params.layerId = this.layerData.id
      const { data } = await getMarkerList(this.params)
      this.isNext = data.next
      this.total = data.total
      let records = data.records
      this.cacheDatas = []
      if (records.length > this.params.pageSize) {
        this.cacheDatas = records
        const start = (this.params.pageNumber - 1) * this.params.pageSize
        let end = (this.params.pageNumber) * this.params.pageSize
        if (end > this.cacheDatas.length) {
          end = this.cacheDatas.length
        }
        records = records.slice(start, end)
      }
      records.forEach((item) => {
        const lon = item.geoJson.geometry.coordinates[0]
        const lat = item.geoJson.geometry.coordinates[1]
        let height = item.geoJson.geometry.coordinates[2]
        if (item.geoJson.properties.height_) {
          height = JSON.parse(item.geoJson.properties.height_)[0]
        }
        const markerData = {
          'name': item.name,
          'deviceId': item.deviceId,
          'marker_lon': lon,
          'marker_lat': lat,
          'marker_height': height,
          'mark_id_': item.id
        }
        this.tableData.push(markerData)
        // 将作为下拉项的列回显为中文
        // Object.keys(item.geoJson.properties).forEach(k => {
        //   if (!item.customize) {
        //     this.$set(item.geoJson.properties, this.customObj[k], item.geoJson.properties[k])
        //   }
        //   const arr = []
        //   this.columns.forEach(c => {
        //     if (c.prop === k && c.type === 'SELECT' && item.geoJson.properties[k]) {
        //       item.geoJson.properties[k].split(',').forEach(p => {
        //         c.options.forEach(o => {
        //           if (o.id.toString() === p) {
        //             arr.push(o.value)
        //           }
        //         })
        //       })
        //       item.geoJson.properties[k] = arr.toString()
        //     }
        //     // 回显日期
        //     if (c.prop === k && c.type === 'DATE' && item.geoJson.properties[k]) {
        //       item.geoJson.properties[k] = new Date(item.geoJson.properties[k]).format('yyyy-MM-dd')
        //     }
        //     // 回显日期时间
        //     if (c.prop === k && c.type === 'DATE_TIME' && item.geoJson.properties[k]) {
        //       item.geoJson.properties[k] = new Date(item.geoJson.properties[k]).format('yyyy-MM-dd hh:mm:ss')
        //     }
        //     // 点标注添加经纬高
        //     if (item.geoJson.geometry.type === 'Point') {
        //       const lon = item.geoJson.geometry.coordinates[0]
        //       const lat = item.geoJson.geometry.coordinates[1]
        //       let height = item.geoJson.geometry.coordinates[2]
        //       if (item.geoJson.properties.height_) {
        //         height = JSON.parse(item.geoJson.properties.height_)[0]
        //       }
        //       item.geoJson.properties.marker_lon = parseFloat(lon).toFixed(6)
        //       item.geoJson.properties.marker_lat = parseFloat(lat).toFixed(6)
        //       item.geoJson.properties.marker_height = height ? parseFloat(height).toFixed(3) : 0
        //     }
        //   })
        // })
        // this.tableData.push(item.geoJson.properties)
      })
      if (this.tableData.length < this.cacheDatas.length) {
        this.isNext = true
      }
      this.loading = false
    },
    // 刷新表格数据
    async refreshTableData () {
      this.reset()
      await this.$nextTick()
      this.getTableHeader()
      // await this.getApiConfig()
      // this.updateApiData(this.apiSourceDatas)
      this.loadAllData()
      // this.loadMore()
    },
    open () {
      this.isShow = true
      this.params.pageNumber = 1
    },
    close () {
      this.$emit('closeMarkerTable')
      this.$emit('updateMarkerTable')
      this.isShow = false
    },
    clickItem (row) {
      const markerId = row[this.gisHeader.markerId]
      this.selectedRowId = markerId
      this.$emit('detailSppucMarker', {
        layer: this.layerData,
        sppucMarkerId: row.mark_id_,
        deviceId: row.deviceId,
        name: row.name
      })
    },
    reset () {
      this.isNext = false
      this.tableData = []
      this.allTableData = []
      this.params.pageNumber = 1
      this.params.pageSize = 20
      this.total = 0
    },
    // 滚动底部加载更多
    async loadMore () {
      this.loading = true
      if (this.layerData.extendConfig.isSppucData) {
        if (this.isNext) {
          this.params.pageNumber++
          const count = Math.min(this.params.pageNumber * this.params.pageSize, this.allTableData.length)
          this.isNext = count < this.allTableData.length
          this.tableData = this.allTableData.slice(0, count)
        }
      } else {
        if (this.isNext) {
          this.params.pageNumber++
          await this.loadMarkers(this.params)
        }
      }
      this.loading = false
    },
    // 点击编辑
    openEdit (row) {
      this.$emit('editMarker', { id: row.mark_id_ })
    },
    deleteOne (row) {
      this.$Delete({
        confirm: () => {
          delMarker({ ids: [row.mark_id_] }).then(res => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              if (row.mark_id_ === this.selectedRowId) {
                this.operatLayout.showMarkerDetail(false)
              }
              this.$cesiumPlus.markerManager.removeMarkerById(row.mark_id_)
              this.refreshTableData()
              this.$emit('refresh')
            }
          })
        },
        cancel: () => {
        }
      })
    },
    deleteMore () {
      if (this.selectedData.length === 0) {
        this.$Message('warning', '请先勾选数据！')
      } else {
        const ids = []
        this.selectedData.forEach((item) => {
          ids.push(item.mark_id_)
        })
        this.$Delete({
          confirm: () => {
            delMarker({ ids: ids }).then(res => {
              if (res.code === 200) {
                this.$Message('success', res.msg)
                if (ids.indexOf(this.selectedRowId) >= 0) {
                  this.operatLayout.showMarkerDetail(false)
                }
                for (let i = 0; i < ids.length; i++) {
                  this.$cesiumPlus.markerManager.removeMarkerById(ids[i])
                }
                this.refreshTableData()
                this.selectedData = []
                this.$emit('refresh')
              }
            })
          },
          cancel: () => {
          }
        })
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.sppucDataTable{
  width: 100%;
  height: 289px;
  background: #272829;
  box-shadow: 2px 0px 6px 0px rgba(12, 35, 91, 0.1);
  // z-index: 100;
  position: absolute;
  bottom: 0;
  // left: 260px;
  padding: 0 12px 12px 12px;
  box-sizing: border-box;
  transition: all 0.3s;
  .makerTableContent{
    box-shadow: 2px 0px 6px 0px rgba(12, 35, 91, 0.1);
    height: 100%;
  }
  // &[shared]{
  //    width: 1660px !important;
  // }
  .header{
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      .name{
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
      }
      .text{
        color: rgba(153, 153, 153, 1);
      }
    }
    .right{
      display: flex;
      align-items: center;
      justify-content: space-between;
      // width: 150px;
      .custom-icon{
        margin-right: 10px;
        >svg{
          color: white !important;
        }
      }
      .line{
        width: 1px;
        height: 14px;
        background: #FFFFFF;
        opacity: 0.1;
        border-radius: 1px;
      }
    }
  }
  .tableBox{
    height: calc(100% - 36px);
    .el-table{
      height: 100%;
      background-color: #272829;
      .el-table__body-wrapper{
        height: calc(100% - 40px) !important;
      }
    }
  }

  .custom-empty {
    margin-bottom: 0px;
  }
  .flex{
    display: flex;
  }
}
</style>
